import {get} from "lodash"
import {
  LOAD_RESULTS,
  PEND_LOAD_RESULTS,
  UPDATE_RESULTS,
  CLEAR_RESULTS,
  NEW_URL_QUERY_TERM,
  NEW_URL_LAT_LNG,
  NEW_URL_RADIUS,
  NEW_URL_BOUNDING_BOX,
  SET_SEARCH_RESULTS_INPUT,
  CLEAR_PEND
} from "../actions/SearchActions"


/**
 * Main search reducer
 *
 *
 * @param state
 * @param action
 * @returns {*}
 * @constructor
 */
const SearchReducer = (state = {results: {total: 0}}, action) => {
  switch (action.type) {
    case NEW_URL_QUERY_TERM:
      return {
        ...state,
        q: get(action, "search.q", "")
      }
    case NEW_URL_LAT_LNG:
      return {
        ...state,
        lat: get(action, "search.lat", ""),
        lng: get(action, "search.lng", "")
      }
    case NEW_URL_RADIUS:
      return {
        ...state,
        radius: get(action, "search.radius", "")
      }
    case NEW_URL_BOUNDING_BOX:
      return {
        ...state,
        boundingBox: get(action, "search.boundingBox", "")
      }
    case LOAD_RESULTS:
      return {
        ...state,
        load: get(action, "search.load")
      }
    case PEND_LOAD_RESULTS:
      return {
        ...state,
        load: new Promise(() => {
        })
      }
    case UPDATE_RESULTS:
      return {
        ...state,
        lastSuccessfulQ: get(action, "search.lastSuccessfulQ"),
        lastSuccessfulLat: get(action, "search.lastSuccessfulLat"),
        lastSuccessfulLng: get(action, "search.lastSuccessfulLng"),
        lastSuccessfulRadius: get(action, "search.lastSuccessfulRadius"),
        lastSuccessfulBoundingBox: get(action, "search.lastSuccessfulBoundingBox"),
        results: get(action, "search.results.data.results"),
        load: null
      }
    case CLEAR_RESULTS:
      return {
        ...state,
        load: null,
        lastSuccessfulQ: null,
        lastSuccessfulLat: null,
        lastSuccessfulLng: null,
        lastSuccessfulRadius: null,
        lastSuccessfulBoundingBox: null,
        q: null,
        lat: null,
        lng: null,
        radius: null,
        boundingBox: null,
        results: {
          deals: [],
          categories: []
        }
      }
    case SET_SEARCH_RESULTS_INPUT:
      return {
        ...state,
        searchResultsInput: get(action, "search.input")
      }
    case CLEAR_PEND:
      return {
        ...state,
        load: null
      }
    default:
      return state
  }
}

export default SearchReducer
